import React from 'react'
import PropTypes from 'prop-types'
import style from './CheckboxFilter.less'
import DropDownFilterBase from '../DropDownFilterBase/DropDownFilterBase'
import CheckboxFilterOption from './CheckboxFilterOption'

class CheckboxFilter extends DropDownFilterBase {
  constructor(props) {
    super(props)
    this.dataAR = [...props.data.map((item) => item.data)]
    this.state = {
      checkBoxAr: [],
    }
  }

  onChange = (index) => {
    const { logEvent, data, type } = this.props
    const validIndex = this.state.checkBoxAr.indexOf(index)
    const checkBoxAr = [...this.state.checkBoxAr]

    const gaLabel = `${type}:${data[index].type}`

    if (validIndex > -1) {
      logEvent(
        'Tickets',
        'RemoveFilter',
        gaLabel,
      )
      checkBoxAr.splice(validIndex, 1)
    } else {
      logEvent(
        'Tickets',
        'AddFilter',
        gaLabel,
      )
      checkBoxAr.push(index)
    }
    this.setState({ checkBoxAr })
  }

  checkBoxtoggleClick = (evt) => {
    if (!this.props.disabled) {
      this.toggleClick(evt)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.transportMode !== this.props.transportMode) {
      this.setState({
        checkBoxAr: [],
      })
      this.props.onChange(this.dataAR)
    } else if (nextProps.data === this.props.data) {
      return
    }

    this.dataAR = [...nextProps.data.map((item) => item.data)]
    if (this.state.checkBoxAr.length !== 0) {
      const returnAr = this.state.checkBoxAr.map((checkboxAr) => this.dataAR[checkboxAr])
      this.props.onChange(returnAr)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.checkBoxAr !== this.state.checkBoxAr) {
      if (this.state.checkBoxAr.length === 0) {
        this.props.onChange(this.dataAR)
      } else {
        const returnAr = this.state.checkBoxAr.map((checkboxAr) => this.dataAR[checkboxAr])
        this.props.onChange(returnAr)
      }
    }
  }

  render() {
    const { children, data, showLength, label } = this.props
    return (
      <div className={style.wrapper} data-test={label.props.id}>
        <div onClick={this.checkBoxtoggleClick}>
          {children}
        </div>
        {this.state.open &&
          <div className={style.dropdown} data-test="checkBoxFilterDropDown">
            {data.map((item, index) =>
              <CheckboxFilterOption
                key={index}
                item={item}
                onChange={this.onChange}
                index={index}
                showLength={showLength}
                checked={(this.state.checkBoxAr.indexOf(index) > -1)}
              />
            )}
          </div>
        }
      </div>
    )
  }
}

CheckboxFilter.defaultProps = {
  showLength: true,
}

CheckboxFilter.propTypes = {
  children: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  logEvent: PropTypes.func.isRequired,
  label: PropTypes.object,
  type: PropTypes.string,
  showLength: PropTypes.bool,
  transportMode: PropTypes.string,
  disabled: PropTypes.bool,
}

export default CheckboxFilter
